(function() {
  if (!window.WimPromoSettings) return;

  const config = window.WimPromoSettings;
  const GIFT_VARIANT_ID = config.gift_variant_id ? config.gift_variant_id.toString() : null;
  
  if (!GIFT_VARIANT_ID) return;

  // Split and clean SKUs
  const group1Skus = (config.group1_skus || '').split(',').map(s => s.trim()).filter(Boolean);
  const group2Skus = (config.group2_skus || '').split(',').map(s => s.trim()).filter(Boolean);

  let isUpdating = false;

  async function checkCartForPromo() {
    if (isUpdating) return;
    
    try {
      const response = await window.fetch('/cart.js');
      const cart = await response.json();
      
      let hasGroup1 = group1Skus.length === 0; // Si está vacío, no es un requisito
      let hasGroup2 = group2Skus.length === 0; // Si está vacío, no es un requisito
      let giftItemKey = null;
      let giftQty = 0;

      for (const item of cart.items) {
        if (!hasGroup1 && group1Skus.includes(item.sku)) hasGroup1 = true;
        if (!hasGroup2 && group2Skus.includes(item.sku)) hasGroup2 = true;
        
        if (item.variant_id.toString() === GIFT_VARIANT_ID) {
          giftItemKey = item.key;
          giftQty = item.quantity;
        }
      }

      // Se deben cumplir ambos grupos (o estar vacíos)
      const meetsConditions = hasGroup1 && hasGroup2;

      if (meetsConditions && giftQty === 0) {
        // Añadir el regalo
        isUpdating = true;
        await window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
          })
        });
        
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        isUpdating = false;

      } else if (!meetsConditions && giftQty > 0) {
        // Eliminar el regalo
        isUpdating = true;
        await window.fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftItemKey,
            quantity: 0
          })
        });
        
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        isUpdating = false;
      }

    } catch (e) {
      console.error('Error auto-adding promo item:', e);
      isUpdating = false;
    }
  }

  // Interceptar llamadas a fetch para detectar actualizaciones del carrito
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    
    // Si la llamada fue para modificar el carrito, chequeamos la promo
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      // Evitamos un loop infinito verificando el flag
      if (!isUpdating) {
        setTimeout(checkCartForPromo, 300);
      }
    }
    return response;
  };

  // Interceptar llamadas XHR antiguas
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this.responseURL && (
          this.responseURL.includes('/cart/add') || 
          this.responseURL.includes('/cart/change') || 
          this.responseURL.includes('/cart/update') || 
          this.responseURL.includes('/cart/clear'))) {
        if (!isUpdating) {
          setTimeout(checkCartForPromo, 300);
        }
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  // Chequear al cargar la página por si el carrito ya tenía los productos
  document.addEventListener('DOMContentLoaded', () => {
    checkCartForPromo();
  });

})();
